
import './Button.css';

function Buttons({name}){
    return <button className='btnSh'>{name}</button>
}
export default Buttons;